let test;
let err;
const groupSimilar = arr => {
   return arr.reduce((acc, val) => {
      const { data, map } = acc;
      const ind = map.get(val);
      if(map.has(val)){
         data[ind][1]++;
      } else {
         map.set(val, data.push([val, 1])-1);
      }
      return { data, map };
   }, {
      data: [],
      map: new Map()
   }).data;
};
if (!customElements.get('product-form-kit')) {

  customElements.define('product-form-kit', class ProductFormKit extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return;

      this.handleErrorMessage();
      this.cartNotification.setActiveElement(document.activeElement);

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      /* The formData object is built in JavaScript, so the Content-Type */
      /*   should be set to application/json in the headers object       */
      config.headers['Content-Type'] = 'application/json';

      const rawFormData = new FormData(this.form);

      const kitID = `${rawFormData.get('id')}`
      const bundleID = Date.now() + Math.floor(Math.random()*(100-1+1)+1)

      const groupedItems = groupSimilar(rawFormData.getAll('childVariants'))
      let items = groupedItems.map(groupedItem => {
        return {
          id: groupedItem[0],
          quantity: groupedItem[1],
          properties: {
            _parentVariantId: kitID,
            _parentBundleId: bundleID
          }
        }
      });

      items.push({
        id: rawFormData.get('id'),
        quantity: rawFormData.get('quantity'),
        properties: {
          _isKitProduct: true,
          _kitID: kitID,
          _bundleID: bundleID
        }
      });

      let sections = this.cartNotification.getSectionsToRender().map((section) => section.id);
      let sections_url = window.location.pathname;

      let formData = {
        items,
        sections,
        sections_url
      }

      config.body = JSON.stringify(formData);

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description.replace("/ Bundle Item","").replace("/ Bundle",""));

            // remove items if error
            if(response.status == 422 || response.status == "422"){
              err = true
            }
            return;
          }

          this.cartNotification.renderContents(response);
          document.querySelector('.cart-items')?.classList.toggle('is-empty', response.quantity === 0);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally( async () => {

          window.stop();
                    if(err == true){
              let data = JSON.stringify(formData);
              data = JSON.parse(data);
              delete data.items[0].properties
              delete data.items[1].properties
              delete data.items[2].properties
                      try {
                        
              delete data.items[3].properties
                      } catch (error) {
                        console.log(error)
                      }
              test = data;
              data.items[0].quantity = 0;
            
              data.items[1].quantity = 0;
              data.items[2].quantity = 0;
                      try {
                        
              data.items[3].quantity = 0;
                      } catch (error) {
                        
                        console.log(error)
                      }
            console.log(data.items[0], '\n 1items', data.items[1], '\n 2', data.items[2], '\n 3',data.items[3], '\n 4' )
             await fetch("/cart/change.js", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: data.items[0]
              });
              await fetch("/cart/change.js", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: data.items[1]
              });
              await fetch("/cart/change.js", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: data.items[2]
              });
              await fetch("/cart/change.js", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: data.items[3]
              });
              fetch("/cart.js", {
                method: "GET",
                headers: {
                  "Content-Type": "application/json",
                }
              });
          }
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');


        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }

      
    }
  });
}
